import axios from 'axios';

import { REQUEST_REASON } from 'RestAPIs/endpoints';

export interface RequestListValue {
  name: string;
  id: number;
}

export const getRequestReasonValues = () => {
  return axios.get<RequestListValue[]>(`${REQUEST_REASON}`);
};
